// extracted by mini-css-extract-plugin
module.exports = {"container":"_6444e049b8--container--knSiL","text":"_6444e049b8--text--ykBW6"};